export default "__VITE_ASSET__2txKz2xR__"